<ng-container>
  <div class="error-container">
    <div class="error-absolute">
      <h1 class="heading-size-2">Error</h1>
      <div>Något har gått fel</div>
    </div>
  </div>
</ng-container>
